import React from "react";
import {Container} from "react-bootstrap";
import CustomButton from "../../components/CustomButton";
import {HomeSectionStyled} from "./home.styled";
import homeImg from "../../assets/home-bg.gif";
import { Typewriter } from 'react-simple-typewriter';
import styled from 'styled-components';
// import { Cursor } from 'react-simple-typewriter';

const Home = () => {

  return (
    <HomeSectionStyled
      id={"home"}
      className="home-sec d-flex align-items-center"
      style={{
        background: `url(${homeImg}) top center repeat`,
        height: "calc(80vh - 100px)",
        backgroundSize: 1000, 
        backgroundAttachment: "fixed",
      }}
    >
      
      <Container className="home-container animate__animated animate__lightSpeedInLeft">
        
        <h1> Revolutionizing Manufacturing with 
          <span style={{color: 'dark gray', fontWeight: 'bold', marginLeft:"10px"}}>
            <Typewriter
            loop
            cursor
            cursorStyle="|"
            typeSpeed={50}
            deleteSpeed={50}
            delaySpeed={1000}
            words={['Computer Vision Solutions',]}
            />
          </span>
        </h1>
        <h2>
          
        </h2>
        <h9>
        Computer vision solutions in manufacturing can enhance quality control, increase efficiency, and improve safety through automated inspection, defect detection, and real-time monitoring of production processes........
        </h9>
        <h2>
          
        </h2>

<CustomButton onClick={() => {
  const contactSection = document.getElementById('contact');
  contactSection.scrollIntoView({ behavior: 'smooth' });
}} style={{backgroundColor: 'transparent', border: '2px solid white'}}>Speak with an AI Expert</CustomButton>
     
      </Container>
    </HomeSectionStyled>
  );
};

export default Home;
